import { Mic, Wand2, Save } from "lucide-react";

const STEPS = [
  {
    n: "01",
    title: "Speak naturally",
    body: "Tap the microphone and talk through the session like you would to a colleague. Mention Assessment, Objective, Goals, History — TherapyNote listens live.",
    Icon: Mic,
  },
  {
    n: "02",
    title: "AI fills the fields",
    body: "Claude reads the transcript, recognises the clinical sections you spoke, and drops each part into the right tab — Evaluation or Daily Notes.",
    Icon: Wand2,
  },
  {
    n: "03",
    title: "Review & save",
    body: "Scan the result, copy a single field to your EMR, email it to yourself, or save the full plan to that patient's timeline. Done in under a minute.",
    Icon: Save,
  },
];

export default function HowItWorks() {
  return (
    <section
      id="how-it-works"
      className="bg-[#FAFAFA] py-20 md:py-32"
      data-testid="how-it-works-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-3xl">
          <span className="font-figtree text-xs uppercase tracking-[0.22em] font-semibold text-[#059669]">
            How it works
          </span>
          <h2 className="mt-3 font-outfit text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-[#0F172A] leading-[1.1]">
            Clinical documentation in under a minute.
          </h2>
          <p className="mt-4 font-figtree text-base sm:text-lg text-[#475569] leading-relaxed">
            Three taps. No new vocabulary. No template wrangling. You talk the way
            you already think.
          </p>
        </div>

        <div className="mt-14 grid lg:grid-cols-12 gap-8 items-stretch">
          {/* Left: large image card */}
          <div className="lg:col-span-5 relative">
            <div className="rounded-3xl overflow-hidden h-full min-h-[420px] shadow-[0_20px_40px_rgba(15,23,42,0.08)] border border-slate-100 bg-white">
              <img
                src="https://static.prod-images.emergentagent.com/jobs/d066d172-2191-4a64-b7f6-08cdd9cfdc8c/images/8a7f9afc73616dce5e126d81baae1691457bcb0dadadc8474c28ad87dad640c3.png"
                alt="Voice recording interface mockup"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          {/* Right: 3 steps stacked */}
          <div className="lg:col-span-7 flex flex-col gap-5">
            {STEPS.map(({ n, title, body, Icon }, i) => (
              <div
                key={n}
                data-testid={`how-step-${i + 1}`}
                className="group bg-white border border-slate-100 rounded-3xl p-6 md:p-7 shadow-soft shadow-lift-hover flex gap-5 items-start"
              >
                <div className="flex-shrink-0 flex flex-col items-center">
                  <span className="inline-flex items-center justify-center w-12 h-12 rounded-2xl bg-[#D1FAE5] text-[#059669] group-hover:bg-[#10B981] group-hover:text-white transition-colors">
                    <Icon className="w-5 h-5" />
                  </span>
                  <span className="mt-2 font-outfit text-xs font-semibold tracking-widest text-[#94A3B8]">
                    {n}
                  </span>
                </div>
                <div>
                  <h3 className="font-outfit text-xl md:text-2xl font-semibold text-[#0F172A] tracking-tight">
                    {title}
                  </h3>
                  <p className="mt-2 font-figtree text-sm md:text-base text-[#475569] leading-relaxed">
                    {body}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
